import type {BlogCategory} from '@/types/blog'

// Sanity stores canonical English category values and filtering compares
// against them (a.categories.includes(tag)), so the values themselves must
// not be localized — only their display labels are.
export const BLOG_CATEGORY_KEYS: Record<BlogCategory, string> = {
  Learn: 'blog.categories.learn',
  Teach: 'blog.categories.teach',
  Live: 'blog.categories.live',
  Insights: 'blog.categories.insights',
  'Inside Jynio': 'blog.categories.insideJynio',
}

// Unknown tags (a category added in Sanity before the frontend catches up)
// fall back to the raw value rather than a missing-key artifact.
export const blogCategoryLabel = (t: (key: string) => string, tag: string) => {
  const key = BLOG_CATEGORY_KEYS[tag as BlogCategory]
  return key ? t(key) : tag
}
